export default __webpack_public_path__ + "static/media/2.47fc9563.png";